import { tm } from '@captaincause/ui/tm'
import { Footer } from 'components/Footer'
import { Nav } from 'components/Nav'
import { Banner } from 'components/Banner'
import type { LayoutProps } from './App'

export function NavAndFooterLayout({
  children,
  pageProps = undefined,
  className,
}: LayoutProps) {
  return (
    <div id="layout" className={tm(className, 'flex flex-col')}>
      <Banner {...(pageProps?.banner ?? {})} />
      <Nav localizations={pageProps?.localizations ?? []} />
      {children}
      <Footer hideFooterCta={pageProps?.hideFooterCta ?? false} />
    </div>
  )
}
